import { createStore } from 'vuex'

export default createStore({
  state: {
    userInfo: JSON.parse(localStorage.getItem('userInfo')),
    tipsInfo: { isShow: false, msg: '', second: 2, callback: '' },
    appId: 'wxc10a47968eb2d8f2',
    loading: false,
    serachContent: '',
    isCustomCustomer: false,
    supplierId: 0,
    supplierName: '',
    supplierAvatar: ''
  },
  mutations: {
    showMsg (state, param) {
      state.tipsInfo = param
    }
  },
  actions: {
  },
  modules: {
  }
})
